import React from "react";
import FailIcon from "../FailIcon/FailIcon";
import "./Fail.css";

const Fail = (props) => {
  return (
    <>
      <FailIcon />
      <h2 className="headline-4 fail-title">Oops something went wrong!</h2>
      <p className="fail-message body-text">Please try again later.</p>
    </>
  );
};

export default Fail;
